import { createActionCreator } from "common/ReduxUtils";
import { StorageInboundCreateActionTypes } from "../StorageInboundCreateAction.types";

export const resetStorageInboundCreate = createActionCreator(
  StorageInboundCreateActionTypes.RESET_STORAGE_INBOUND_CREATE
);
